import { render, staticRenderFns } from "./responsiblePersonsEditView.vue?vue&type=template&id=53b87550&scoped=true"
import script from "./responsiblePersonsEditView.vue?vue&type=script&lang=js"
export * from "./responsiblePersonsEditView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b87550",
  null
  
)

export default component.exports